import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { loadInvitation } from '../api/acceptInvitationLoad'
import { confirmInvitation } from '../api/acceptInvitationConfirm'
import { apiRequest } from '../utils/apiRequest'

export function useAcceptInvitation() {
  const location = useLocation()
  const invitationToken = new URLSearchParams(location.search).get(
    'invitation_token',
  )

  const [state, setState] = useState({
    loaded: false,
    loadingError: !invitationToken,
    confirmed: false,
    confirmationError: '',
    name: '',
    email: '',
    isUserActive: false,
    disabledForm: false,
  })

  const [seenToken, setSeenToken] = useState(invitationToken)
  if (seenToken !== invitationToken) {
    setSeenToken(invitationToken)
    if (invitationToken) {
      setState((s) => ({
        ...s,
        loaded: false,
        loadingError: false,
        name: '',
        email: '',
      }))
    }
  }

  useEffect(() => {
    if (!invitationToken) return
    // Ignore results of requests started for a previous token.
    let cancelled = false
    apiRequest(loadInvitation, { invitationToken })
      .then(({ name, email } = {}) => {
        if (!cancelled) setState((s) => ({ ...s, loaded: true, name, email }))
      })
      .catch(() => {
        if (!cancelled) setState((s) => ({ ...s, loadingError: true }))
      })
    return () => {
      cancelled = true
    }
  }, [invitationToken])

  const confirm = async ({
    password,
    passwordConfirmation,
    recaptchaResponse,
  }) => {
    setState((s) => ({ ...s, disabledForm: true }))
    try {
      const result = await apiRequest(confirmInvitation, {
        token: invitationToken,
        user_password: password,
        user_password_confirmation: passwordConfirmation,
        'g-recaptcha-response': recaptchaResponse,
      })
      setState((s) => ({
        ...s,
        confirmed: true,
        isUserActive: !!result?.active,
        disabledForm: false,
      }))
    } catch (error) {
      setState((s) => ({
        ...s,
        confirmationError: error.message,
        disabledForm: false,
      }))
    }
  }

  return { ...state, invitationToken, confirm }
}
